import * as TYPES from './constants';

// theme
export const changeAppThemeMode = data => ({
  type: TYPES.CHANGE_APP_THEME_MODE,
  payload: data,
});
export const toggleAppDrawer = data => ({
  type: TYPES.TOGGLE_APP_DRAWER,
  payload: data,
});

//SRM Super User License Types
export const requestSuperUserLicenseTypes = () => ({
  type: TYPES.REQUEST_SUPER_USER_LICENSE_TYPES,
});
export const receiveSuperUserLicenseTypes = json => ({
  type: TYPES.RECEIVE_SUPER_USER_LICENSE_TYPES,
  payload: json,
});
export const handleSuperUserLicenseTypesError = err => ({
  type: TYPES.SUPER_USER_LICENSE_TYPES_ERROR,
  err,
});

// send message

export const sendMessageOpen = data => ({
  type: TYPES.SEND_MESSAGE_OPEN,
  payload: data,
});
export const sendMessageClose = data => ({
  type: TYPES.SEND_MESSAGE_CLOSE,
  payload: data,
});

//User Types
export const requestUserTypes = () => ({
  type: TYPES.REQUEST_USER_TYPES,
});
export const receiveUserTypes = json => ({
  type: TYPES.RECEIVE_USER_TYPES,
  payload: json,
});
export const handleUserTypesError = err => ({
  type: TYPES.USER_TYPES_ERROR,
  err,
});

// New Industry sector list
export const requestIndustrySector = () => ({
  type: TYPES.REQUEST_INDUSTRY_SECTOR,
});
export const receiveIndustrySector = json => ({
  type: TYPES.RECEIVE_INDUSTRY_SECTOR,
  payload: json,
});
export const industrySectorError = err => ({
  type: TYPES.INDUSTRY_SECTOR_ERROR,
  err,
});
